import {updateScriptTagsInHtml} from '../updateScriptTagsInHtml';
import {excludeCommentedCode} from '../excludeCommentedCode';

/**
 * Ensures that we make all needed manipulation over custom code as it is stored in the backend for it to work accordingly
 * to the product expectation in the Preview and Commenting modes.
 */
export const prepareCustomCodeForExecutionInCanvasApp = (fragment: string) => {
  return updateScriptTagsInHtml(excludeCommentedCode(fragment));
};
